// ServiceNear onboarding steps and slip themes - kept apart from the component so the dashboard/onboarding service can import them without the component
export interface ServicenearOnboardingStep {
  key: string;
  title: string;
  subtitle: string;
  icon: string;
}

/** Step keys are logged through Seller/SaveSellerOnBoardingStatus as "<key> saved|skipped". */
export const SERVICENEAR_ONBOARDING_STEPS: ServicenearOnboardingStep[] = [
  { key: 'sn-basicdetails', title: 'Business details', subtitle: 'Tell your customers who you are and where to find you', icon: 'bi-shop' },
  { key: 'sn-subscription', title: 'Choose your plan', subtitle: 'Pick the plan that fits your service center', icon: 'bi-gem' },
  // key kept as 'sn-uniqueid' so already logged steps still match
  { key: 'sn-uniqueid', title: 'Service settings', subtitle: 'Staff login ID, job slip printing and WhatsApp', icon: 'bi-sliders' },
];

/** Job slip colour themes - saved as PrintHeader.JobNumberColor / ContactColor of the ServiceNear print settings. */
export const SERVICENEAR_PRINT_THEMES = [
  { key: 'classic', name: 'Classic', jobColor: 'black', contactColor: 'black' },
  { key: 'violet', name: 'Violet', jobColor: '#673AB7', contactColor: '#3b0d7a' },
  { key: 'ocean', name: 'Ocean', jobColor: '#1565c0', contactColor: '#0d47a1' },
  { key: 'sunset', name: 'Sunset', jobColor: '#ef6c00', contactColor: '#c62828' },
  { key: 'forest', name: 'Forest', jobColor: '#2e7d32', contactColor: '#1b5e20' },
  { key: 'teal', name: 'Teal', jobColor: '#00897b', contactColor: '#004d40' },
  { key: 'royal', name: 'Royal', jobColor: '#283593', contactColor: '#6a1b9a' },
  { key: 'berry', name: 'Berry', jobColor: '#ad1457', contactColor: '#6a1b9a' },
  { key: 'crimson', name: 'Crimson', jobColor: '#c62828', contactColor: '#212121' },
  { key: 'coral', name: 'Coral', jobColor: '#e64a19', contactColor: '#37474f' },
  { key: 'amber', name: 'Amber', jobColor: '#ef8f00', contactColor: '#4e342e' },
  { key: 'mocha', name: 'Mocha', jobColor: '#6d4c41', contactColor: '#3e2723' },
  { key: 'slate', name: 'Slate', jobColor: '#455a64', contactColor: '#263238' },
  { key: 'navy-gold', name: 'Navy Gold', jobColor: '#0d47a1', contactColor: '#c77800' },
  { key: 'emerald', name: 'Emerald', jobColor: '#00796b', contactColor: '#1565c0' },
];

/** Plan card details built from GetAllSubscriptionPlansForSuperAdmin (plan + Features). */
export interface PlanDetailRow {
  label: string;
  value: string;
}

export interface PlanModule {
  key: string;
  label: string;
}

export interface PlanDetails {
  priceLabel: string;
  cycleLabel: string;
  info: PlanDetailRow[];
  limits: PlanDetailRow[];
  modulesIncluded: PlanModule[];
  modulesExcluded: PlanModule[];
}

/** Readable names of the FeatureAccess module keys (top level of the JSON); unknown keys are title-cased. */
export const MODULE_LABELS: Record<string, string> = {
  dashboard: 'Dashboard',
  pos: 'Sales POS',
  secondhand: 'Secondhand',
  whatsapp: 'WhatsApp',
  reports: 'Reports',
  user: 'Staff users',
  customer: 'Customers',
  vendor: 'Vendors',
};
